/*Import Estilo*/
import './index.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';
import MenuLateral from '../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../api';
import { useToast } from '../../../context/ToastContext';

export default function SEO() {
    const [abaAtiva, setAbaAtiva] = useState('global');
    const { showToast } = useToast();
    const navigate = useNavigate();

    // Estados para Configuração Global
    const [configGlobal, setConfigGlobal] = useState({
        site_title: '',
        site_description: '',
        site_keywords: '',
        site_author: '',
        og_title: '',
        og_description: '',
        og_image: '',
        og_type: 'website',
        og_site_name: '',
        twitter_card: 'summary',
        twitter_title: '',
        twitter_description: '',
        twitter_image: '',
        twitter_site: '',
        favicon_16: '',
        favicon_32: '',
        favicon_64: '',
        apple_touch_icon: '',
        google_analytics_id: '',
        google_tag_manager_id: '',
        facebook_pixel_id: '',
        google_search_console_code: '',
        bing_webmaster_code: '',
        analytics_ativo: false
    });

    // Estados para Redirecionamentos
    const [redirecionamentos, setRedirecionamentos] = useState([]);
    const [novoRedirect, setNovoRedirect] = useState({
        url_origem: '',
        url_destino: '',
        tipo_redirect: 301,
        ativo: true
    });

    // Estados para Sitemap
    const [sitemapXml, setSitemapXml] = useState('');
    const [totalUrls, setTotalUrls] = useState(0);

    // Estados para Categorias e Produtos
    const [categorias, setCategorias] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);

    const [loading, setLoading] = useState(false);

    // Estados para upload de imagens
    const [uploadingImage, setUploadingImage] = useState(false);
    const fileInputOgRef = useRef(null);
    const fileInputTwitterRef = useRef(null);
    const fileInputFaviconRef = useRef(null);
    const fileInputLogoRef = useRef(null);

    // Carregar dados iniciais
    useEffect(() => {
        if (abaAtiva === 'global') {
            carregarConfigGlobal();
        } else if (abaAtiva === 'redirecionamentos') {
            carregarRedirecionamentos();
        } else if (abaAtiva === 'categorias') {
            carregarCategorias();
        } else if (abaAtiva === 'produtos') {
            carregarProdutos();
        }
    }, [abaAtiva]);

    // ========== FUNÇÕES DE CARREGAMENTO ==========
    const carregarConfigGlobal = async () => {
        setLoading(true);
        try {
            const response = await api.get('/seo/config');
            if (response.data.success) {
                setConfigGlobal(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar configurações SEO', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarRedirecionamentos = async () => {
        setLoading(true);
        try {
            const response = await api.get('/seo/redirecionamentos');
            if (response.data.success) {
                setRedirecionamentos(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar redirecionamentos', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarCategorias = async () => {
        setLoading(true);
        try {
            const response = await api.get('/seo/categorias');
            if (response.data.success) {
                setCategorias(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar categorias', 'error');
        } finally {
            setLoading(false);
        }
    };

    const carregarProdutos = async () => {
        setLoading(true);
        try {
            const response = await api.get('/seo/produtos');
            if (response.data.success) {
                setProdutos(response.data.data);
            }
        } catch (error) {
            showToast('Erro ao carregar produtos', 'error');
        } finally {
            setLoading(false);
        }
    };

    // ========== FUNÇÕES DE SALVAMENTO ==========
    const salvarConfigGlobal = async () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);
        try {
            const response = await api.put('/seo/config', configGlobal);
            if (response.data.success) {
                showToast('Configurações SEO atualizadas com sucesso!', 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao salvar configurações', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleUploadImage = async (event, tipo) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validar tipo de arquivo
        if (!file.type.startsWith('image/')) {
            showToast('Por favor, selecione uma imagem válida', 'error');
            return;
        }

        // Validar tamanho (máximo 5MB)
        if (file.size > 5 * 1024 * 1024) {
            showToast('A imagem deve ter no máximo 5MB', 'error');
            return;
        }

        setUploadingImage(true);
        try {
            const formData = new FormData();
            formData.append('imagem', file);
            formData.append('tipo', tipo);

            const response = await api.post('/seo/upload-image', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.data.success) {
                const data = response.data.data;
                
                if (tipo === 'og_image') {
                    setConfigGlobal(prev => ({ ...prev, og_image: data.url }));
                } else if (tipo === 'twitter_image') {
                    setConfigGlobal(prev => ({ ...prev, twitter_image: data.url }));
                } else if (tipo === 'favicon') {
                    setConfigGlobal(prev => ({
                        ...prev,
                        favicon_16: data.favicon_16,
                        favicon_32: data.favicon_32,
                        favicon_64: data.favicon_64
                    }));
                } else if (tipo === 'apple_touch_icon') {
                    setConfigGlobal(prev => ({
                        ...prev,
                        apple_touch_icon: data.apple_touch_icon
                    }));
                }

                showToast('Imagem enviada e salva com sucesso!', 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao fazer upload da imagem', 'error');
        } finally {
            setUploadingImage(false);
            // Limpar o input file
            if (tipo === 'og_image' && fileInputOgRef.current) {
                fileInputOgRef.current.value = '';
            } else if (tipo === 'twitter_image' && fileInputTwitterRef.current) {
                fileInputTwitterRef.current.value = '';
            } else if (tipo === 'favicon' && fileInputFaviconRef.current) {
                fileInputFaviconRef.current.value = '';
            } else if (tipo === 'apple_touch_icon' && fileInputLogoRef.current) {
                fileInputLogoRef.current.value = '';
            }
        }
    };

    const criarRedirecionamento = async () => {
        if (!novoRedirect.url_origem || !novoRedirect.url_destino) {
            showToast('Preencha origem e destino', 'error');
            return;
        }

        setLoading(true);
        try {
            const response = await api.post('/seo/redirecionamentos', novoRedirect);
            if (response.data.success) {
                showToast('Redirecionamento criado com sucesso!', 'success');
                setNovoRedirect({ url_origem: '', url_destino: '', tipo_redirect: 301, ativo: true });
                carregarRedirecionamentos();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao criar redirecionamento', 'error');
        } finally {
            setLoading(false);
        }
    };

    const excluirRedirecionamento = async (id) => {
        if (!window.confirm('Deseja excluir este redirecionamento?')) return;

        setLoading(true);
        try {
            const response = await api.delete(`/seo/redirecionamentos/${id}`);
            if (response.data.success) {
                showToast('Redirecionamento excluído com sucesso!', 'success');
                carregarRedirecionamentos();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao excluir redirecionamento', 'error');
        } finally {
            setLoading(false);
        }
    };

    const gerarSitemap = async () => {
        setLoading(true);
        try {
            const response = await api.post('/seo/sitemap/gerar');
            if (response.data.success) {
                setSitemapXml(response.data.data);
                setTotalUrls(response.data.total);
                showToast(`Sitemap gerado com ${response.data.total} URLs!`, 'success');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao gerar sitemap', 'error');
        } finally {
            setLoading(false);
        }
    };

    const atualizarSeoCategoria = async () => {
        if (!categoriaSelecionada) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);
        try {
            const response = await api.put(`/seo/categoria/${categoriaSelecionada.id}`, {
                meta_title: categoriaSelecionada.meta_title,
                meta_description: categoriaSelecionada.meta_description,
                slug: categoriaSelecionada.slug
            });
            if (response.data.success) {
                showToast('SEO da categoria atualizado!', 'success');
                setCategoriaSelecionada(null);
                carregarCategorias();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao atualizar categoria', 'error');
        } finally {
            setLoading(false);
        }
    };

    const atualizarSeoProduto = async () => {
        if (!produtoSelecionado) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);
        try {
            const response = await api.put(`/seo/produto/${produtoSelecionado.id}`, {
                meta_title: produtoSelecionado.meta_title,
                meta_description: produtoSelecionado.meta_description,
                meta_keywords: produtoSelecionado.meta_keywords,
                slug: produtoSelecionado.slug,
                schema_json: produtoSelecionado.schema_json
            });
            if (response.data.success) {
                showToast('SEO do produto atualizado!', 'success');
                setProdutoSelecionado(null);
                carregarProdutos();
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao atualizar produto', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="container-principal-seo">
            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <div className="container-conteudo-seo">
                    <section className='conteudo-seo'>
                        <div className="header-seo">
                            <h1>Gerenciamento SEO</h1>
                            <span>Otimização para motores de busca</span>
                        </div>

                        <div className="tabs-seo">
                            <button
                                className={abaAtiva === 'global' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('global')}
                            >
                                Configuração Global
                            </button>
                            <button
                                className={abaAtiva === 'redirecionamentos' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('redirecionamentos')}
                            >
                                Redirecionamentos
                            </button>
                            <button
                                className={abaAtiva === 'sitemap' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('sitemap')}
                            >
                                Sitemap
                            </button>
                            <button
                                className={abaAtiva === 'categorias' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('categorias')}
                            >
                                SEO Categorias
                            </button>
                            <button
                                className={abaAtiva === 'produtos' ? 'ativo' : ''}
                                onClick={() => setAbaAtiva('produtos')}
                            >
                                SEO Produtos
                            </button>
                        </div>

                        <div className="conteudo-aba-seo">
                            {loading && <div className='loading'>
                                <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                                <h2>Carregando dados do fornecedor</h2>
                            </div>
                            }

                            {/* ABA CONFIGURAÇÃO GLOBAL */}
                            {abaAtiva === 'global' && !loading && (
                                <div className="aba-config-global">
                                    {/* Meta Tags Globais */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Meta Tags Globais</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <div className="form-group">
                                                <label>Meta Title (60 caracteres)</label>
                                                <input
                                                    type="text"
                                                    maxLength="60"
                                                    value={configGlobal.site_title}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, site_title: e.target.value })}
                                                />
                                                <small>{configGlobal.site_title?.length || 0}/60</small>
                                            </div>

                                            <div className="form-group">
                                                <label>Meta Description (160 caracteres)</label>
                                                <textarea
                                                    maxLength="160"
                                                    value={configGlobal.site_description}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, site_description: e.target.value })}
                                                />
                                                <small>{configGlobal.site_description?.length || 0}/160</small>
                                            </div>

                                            <div className="form-group">
                                                <label>Meta Keywords (separadas por vírgula)</label>
                                                <input
                                                    type="text"
                                                    value={configGlobal.site_keywords}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, site_keywords: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Open Graph */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Open Graph (Facebook / Google)</h2>
                                            <small>Imagem recomendada: 1200x630 pixels</small>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <div className="form-group">
                                                <label>OG Title</label>
                                                <input
                                                    type="text"
                                                    value={configGlobal.og_title}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, og_title: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>OG Description</label>
                                                <textarea
                                                    value={configGlobal.og_description}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, og_description: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>OG Site Name</label>
                                                <input
                                                    type="text"
                                                    value={configGlobal.og_site_name}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, og_site_name: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>OG Type</label>
                                                <div className="input-select-wrapper">
                                                    <select
                                                        value={configGlobal.og_type}
                                                        onChange={(e) => setConfigGlobal({ ...configGlobal, og_type: e.target.value })}
                                                    >
                                                        <option value="website">website</option>
                                                        <option value="article">article</option>
                                                        <option value="product">product</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>OG Image (Imagem que aparece no Google e redes sociais)</label>
                                                <div className="upload-image-container">
                                                    {configGlobal.og_image && (
                                                        <div className="image-preview">
                                                            <img src={configGlobal.og_image} alt="OG Preview" />
                                                        </div>
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        ref={fileInputOgRef}
                                                        onChange={(e) => handleUploadImage(e, 'og_image')}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <button 
                                                        type="button"
                                                        className="btn-upload"
                                                        onClick={() => fileInputOgRef.current?.click()}
                                                        disabled={uploadingImage}
                                                    >
                                                        {uploadingImage ? 'Enviando...' : 'Escolher Imagem'}
                                                    </button>
                                                    {configGlobal.og_image && (
                                                        <input
                                                            type="text"
                                                            value={configGlobal.og_image}
                                                            onChange={(e) => setConfigGlobal({ ...configGlobal, og_image: e.target.value })}
                                                            placeholder="ou cole a URL da imagem aqui"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Twitter Cards */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Twitter Cards</h2>
                                            <small>Imagem recomendada: 1200x630 pixels</small>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <div className="form-group">
                                                <label>Twitter Title</label>
                                                <input
                                                    type="text"
                                                    value={configGlobal.twitter_title}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, twitter_title: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Twitter Description</label>
                                                <textarea
                                                    value={configGlobal.twitter_description}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, twitter_description: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Twitter Card</label>
                                                <div className="input-select-wrapper">
                                                    <select
                                                        value={configGlobal.twitter_card}
                                                        onChange={(e) => setConfigGlobal({ ...configGlobal, twitter_card: e.target.value })}
                                                    >
                                                        <option value="summary">summary</option>
                                                        <option value="summary_large_image">summary_large_image</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Twitter Site (ex: @fracarostore)</label>
                                                <input
                                                    type="text"
                                                    value={configGlobal.twitter_site}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, twitter_site: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Twitter Image</label>
                                                <div className="upload-image-container">
                                                    {configGlobal.twitter_image && (
                                                        <div className="image-preview">
                                                            <img src={configGlobal.twitter_image} alt="Twitter Preview" />
                                                        </div>
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        ref={fileInputTwitterRef}
                                                        onChange={(e) => handleUploadImage(e, 'twitter_image')}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <button 
                                                        type="button"
                                                        className="btn-upload"
                                                        onClick={() => fileInputTwitterRef.current?.click()}
                                                        disabled={uploadingImage}
                                                    >
                                                        {uploadingImage ? 'Enviando...' : 'Escolher Imagem'}
                                                    </button>
                                                    {configGlobal.twitter_image && (
                                                        <input
                                                            type="text"
                                                            value={configGlobal.twitter_image}
                                                            onChange={(e) => setConfigGlobal({ ...configGlobal, twitter_image: e.target.value })}
                                                            placeholder="ou cole a URL da imagem aqui"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Favicon e Logo */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Favicon e Logo (Organization)</h2>
                                            <small>Envie uma imagem quadrada (PNG recomendado). Os tamanhos são gerados automaticamente.</small>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <div className="form-group">
                                                <label>Favicon (Imagem que aparece na aba do navegador e no Google)</label>
                                                <div className="upload-image-container">
                                                    {configGlobal.favicon_32 && (
                                                        <div className="image-preview image-preview--small">
                                                            <img src={configGlobal.favicon_32} alt="Favicon Preview" />
                                                        </div>
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept="image/png,image/svg+xml,image/x-icon"
                                                        ref={fileInputFaviconRef}
                                                        onChange={(e) => handleUploadImage(e, 'favicon')}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <button 
                                                        type="button"
                                                        className="btn-upload"
                                                        onClick={() => fileInputFaviconRef.current?.click()}
                                                        disabled={uploadingImage}
                                                    >
                                                        {uploadingImage ? 'Enviando...' : 'Enviar Favicon'}
                                                    </button>
                                                    <small>Envie uma imagem quadrada (PNG). Será redimensionado automaticamente para 48x48, 96x96 e 192x192.</small>
                                                </div>
                                                {configGlobal.favicon_16 && (
                                                    <div className="favicon-urls-geradas">
                                                        <small><strong>48x48:</strong> {configGlobal.favicon_16}</small>
                                                        <small><strong>96x96:</strong> {configGlobal.favicon_32}</small>
                                                        <small><strong>192x192:</strong> {configGlobal.favicon_64}</small>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="form-group">
                                                <label>Logo / Apple Touch Icon (Imagem da marca no Google)</label>
                                                <div className="upload-image-container">
                                                    {configGlobal.apple_touch_icon && (
                                                        <div className="image-preview">
                                                            <img src={configGlobal.apple_touch_icon} alt="Logo Preview" />
                                                        </div>
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept="image/png,image/jpeg,image/svg+xml"
                                                        ref={fileInputLogoRef}
                                                        onChange={(e) => handleUploadImage(e, 'apple_touch_icon')}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <button 
                                                        type="button"
                                                        className="btn-upload"
                                                        onClick={() => fileInputLogoRef.current?.click()}
                                                        disabled={uploadingImage}
                                                    >
                                                        {uploadingImage ? 'Enviando...' : 'Enviar Logo'}
                                                    </button>
                                                    <small>Envie uma imagem quadrada (mín 512x512, fundo limpo). Será usada como Apple Touch Icon e logo no Google.</small>
                                                </div>
                                                {configGlobal.apple_touch_icon && (
                                                    <div className="favicon-urls-geradas">
                                                        <small><strong>URL gerada:</strong> {configGlobal.apple_touch_icon}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Analytics e Tracking */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Analytics e Tracking</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <div className="form-group">
                                                <label>Google Analytics ID (GA4)</label>
                                                <input
                                                    type="text"
                                                    placeholder="G-XXXXXXXXXX"
                                                    value={configGlobal.google_analytics_id}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, google_analytics_id: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Google Tag Manager ID</label>
                                                <input
                                                    type="text"
                                                    placeholder="GTM-XXXXXXX"
                                                    value={configGlobal.google_tag_manager_id}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, google_tag_manager_id: e.target.value })}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Facebook Pixel ID</label>
                                                <input
                                                    type="text"
                                                    value={configGlobal.facebook_pixel_id}
                                                    onChange={(e) => setConfigGlobal({ ...configGlobal, facebook_pixel_id: e.target.value })}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <button className="btn-salvar" onClick={salvarConfigGlobal}>
                                        Salvar Configurações
                                    </button>
                                </div>
                            )}

                            {/* ABA REDIRECIONAMENTOS */}
                            {abaAtiva === 'redirecionamentos' && !loading && (
                                <div className="aba-redirecionamentos">
                                    {/* Criar Novo Redirecionamento */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Criar Novo Redirecionamento</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <div className="form-redirect">
                                                <input
                                                    type="text"
                                                    placeholder="URL de Origem (ex: /antiga-pagina)"
                                                    value={novoRedirect.url_origem}
                                                    onChange={(e) => setNovoRedirect({ ...novoRedirect, url_origem: e.target.value })}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="URL de Destino (ex: /nova-pagina)"
                                                    value={novoRedirect.url_destino}
                                                    onChange={(e) => setNovoRedirect({ ...novoRedirect, url_destino: e.target.value })}
                                                />
                                                <div className='input-ativo'>
                                                    <select
                                                        value={novoRedirect.tipo_redirect}
                                                        onChange={(e) => setNovoRedirect({ ...novoRedirect, tipo_redirect: parseInt(e.target.value) })}
                                                    >
                                                        <option value="301">301 - Permanente</option>
                                                        <option value="302">302 - Temporário</option>
                                                    </select>
                                                </div>
                                                <button onClick={criarRedirecionamento}>Criar</button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Redirecionamentos Existentes */}
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Redirecionamentos Existentes</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <table className="tabela-redirecionamentos">
                                                <thead>
                                                    <tr>
                                                        <th>Origem</th>
                                                        <th>Destino</th>
                                                        <th>Tipo</th>
                                                        <th>Status</th>
                                                        <th>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {redirecionamentos.map(r => (
                                                        <tr key={r.id}>
                                                            <td>{r.url_origem}</td>
                                                            <td>{r.url_destino}</td>
                                                            <td>{r.tipo_redirect}</td>
                                                            <td>{r.ativo ? '✅ Ativo' : '❌ Inativo'}</td>
                                                            <td>
                                                                <button onClick={() => excluirRedirecionamento(r.id)}>Excluir</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ABA SITEMAP */}
                            {abaAtiva === 'sitemap' && !loading && (
                                <div className="aba-sitemap">
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>Gerador de Sitemap</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            <p>Gere automaticamente o sitemap.xml com todas as URLs do site</p>
                                            <button className="btn-gerar-sitemap" onClick={gerarSitemap}>
                                                Gerar Sitemap
                                            </button>
                                            {totalUrls > 0 && (
                                                <div className="sitemap-info">
                                                    <p><strong>Total de URLs:</strong> {totalUrls}</p>
                                                    <textarea
                                                        readOnly
                                                        value={sitemapXml}
                                                        rows="20"
                                                        style={{ width: '100%', fontFamily: 'monospace' }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ABA CATEGORIAS */}
                            {abaAtiva === 'categorias' && !loading && (
                                <div className="aba-categorias-seo">
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>SEO por Categoria</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            {!categoriaSelecionada ? (
                                                <div className="lista-categorias">
                                                    {categorias.map(cat => (
                                                        <div key={cat.id} className="card-categoria" onClick={() => setCategoriaSelecionada(cat)}>
                                                            <h3>{cat.nome}</h3>
                                                            <p>Slug: {cat.slug || 'Não definido'}</p>
                                                            <p>Meta Title: {cat.meta_title || 'Não definido'}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="form-categoria-seo">
                                                    <button onClick={() => setCategoriaSelecionada(null)}>← Voltar</button>
                                                    <h3>Editando: {categoriaSelecionada.nome}</h3>
                                                    <div className="form-group">
                                                        <label>Meta Title</label>
                                                        <input
                                                            type="text"
                                                            value={categoriaSelecionada.meta_title || ''}
                                                            onChange={(e) => setCategoriaSelecionada({ ...categoriaSelecionada, meta_title: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Meta Description</label>
                                                        <textarea
                                                            value={categoriaSelecionada.meta_description || ''}
                                                            onChange={(e) => setCategoriaSelecionada({ ...categoriaSelecionada, meta_description: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Slug (URL amigável)</label>
                                                        <input
                                                            type="text"
                                                            value={categoriaSelecionada.slug || ''}
                                                            onChange={(e) => setCategoriaSelecionada({ ...categoriaSelecionada, slug: e.target.value })}
                                                        />
                                                    </div>
                                                    <button className="btn-salvar" onClick={atualizarSeoCategoria}>Salvar</button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ABA PRODUTOS */}
                            {abaAtiva === 'produtos' && !loading && (
                                <div className="aba-produtos-seo">
                                    <div className="conteudo-secao-seo">
                                        <div className="cabecalho-secao-seo">
                                            <h2>SEO por Produto</h2>
                                        </div>
                                        <div className="dados-secao-seo">
                                            {!produtoSelecionado ? (
                                                <div className="lista-produtos">
                                                    {produtos.map(prod => (
                                                        <div key={prod.id} className="card-produto" onClick={() => setProdutoSelecionado(prod)}>
                                                            <h3>{prod.nome}</h3>
                                                            <p>Slug: {prod.slug || 'Não definido'}</p>
                                                            <p>Meta Title: {prod.meta_title || 'Não definido'}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="form-produto-seo">
                                                    <button onClick={() => setProdutoSelecionado(null)}>← Voltar</button>
                                                    <h3>Editando: {produtoSelecionado.nome}</h3>
                                                    <div className="form-group">
                                                        <label>Meta Title</label>
                                                        <input
                                                            type="text"
                                                            value={produtoSelecionado.meta_title || ''}
                                                            onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, meta_title: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Meta Description</label>
                                                        <textarea
                                                            value={produtoSelecionado.meta_description || ''}
                                                            onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, meta_description: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Meta Keywords</label>
                                                        <input
                                                            type="text"
                                                            value={produtoSelecionado.meta_keywords || ''}
                                                            onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, meta_keywords: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Slug (URL amigável)</label>
                                                        <input
                                                            type="text"
                                                            value={produtoSelecionado.slug || ''}
                                                            onChange={(e) => setProdutoSelecionado({ ...produtoSelecionado, slug: e.target.value })}
                                                        />
                                                    </div>
                                                    <button className="btn-salvar" onClick={atualizarSeoProduto}>Salvar</button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </main>

            <Rodape />
        </section>
    );
}
